module.exports = __webpack_public_path__ + "img/oct-green.97c85f5a.svg";